import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { FaireMarketIcon } from "@faire/retailer-visitor-shared/features/FaireMarkets/FaireMarketIcon";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { clock } from "@faire/web--source/common/clock";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row, VerticalLine } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { eventsThemeColors } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import differenceInDays from "date-fns/differenceInDays";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
export var BrandsLandingPageFaireMarketBanner = function(param) {
    var faireMarketSectionId = param.faireMarketSectionId;
    return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
        mobile: /*#__PURE__*/ _jsx(Container, {
            children: /*#__PURE__*/ _jsxs(Column, {
                children: [
                    /*#__PURE__*/ _jsxs(Row, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ _jsx(SyledIcon, {}),
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: "2x"
                            }),
                            /*#__PURE__*/ _jsx(Title, {})
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "3x"
                    }),
                    /*#__PURE__*/ _jsx(CtaSection, {
                        faireMarketSectionId: faireMarketSectionId
                    })
                ]
            })
        }),
        tabletAndAbove: /*#__PURE__*/ _jsxs(Container, {
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ _jsx(SyledIcon, {}),
                        /*#__PURE__*/ _jsx(Spacer, {
                            width: "2x"
                        }),
                        /*#__PURE__*/ _jsx(Title, {})
                    ]
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    width: "10x"
                }),
                /*#__PURE__*/ _jsx(CtaSection, {
                    faireMarketSectionId: faireMarketSectionId
                })
            ]
        })
    });
};
var CtaSectionBase = function(param) {
    var faireMarketSectionId = param.faireMarketSectionId;
    var startAt = useMarketStore([
        "startAt"
    ]).startAt;
    var difference = differenceInDays(startAt, clock.date());
    return /*#__PURE__*/ _jsxs(CtaSectionWrapper, {
        align: "center",
        children: [
            difference > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansMedium",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "vjDghF",
                            defaultMessage: [
                                {
                                    type: 6,
                                    value: "differenceNumber",
                                    options: {
                                        one: {
                                            value: [
                                                {
                                                    type: 7
                                                },
                                                {
                                                    type: 0,
                                                    value: " day until the market"
                                                }
                                            ]
                                        },
                                        other: {
                                            value: [
                                                {
                                                    type: 7
                                                },
                                                {
                                                    type: 0,
                                                    value: " days until the market"
                                                }
                                            ]
                                        }
                                    },
                                    offset: 0,
                                    pluralType: "cardinal"
                                }
                            ],
                            values: {
                                differenceNumber: difference
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    }),
                    /*#__PURE__*/ _jsx(VerticalLine, {
                        $height: "16px",
                        $color: Core.border.muted
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "2x"
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                linkTo: "#".concat(faireMarketSectionId),
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "7DIW6+",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Learn More"
                        }
                    ]
                })
            })
        ]
    });
};
var CtaSection = observer(CtaSectionBase);
var Title = function() {
    var marketName = useMarketStore([
        "marketName"
    ]).marketName;
    return /*#__PURE__*/ _jsx(Typography, {
        variant: "paragraphSansMedium",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "l8178n",
            defaultMessage: [
                {
                    type: 0,
                    value: "Join Faire in time to sell at "
                },
                {
                    type: 1,
                    value: "marketEventName"
                }
            ],
            values: {
                marketEventName: marketName
            }
        })
    });
};
var Container = styled(Row).attrs({
    align: "center",
    justify: "space-between"
}).withConfig({
    componentId: "sc-84a20acd-0"
})([
    "background-color:",
    ";padding:",
    ";height:fit-content;width:100%;",
    "{padding:",
    ";}"
], eventsThemeColors.faireMarket.lightBackground, getSpacing("3x", "5x"), responsiveMediaQueries.mobile, getSpacing("3x", "3x", "2x"));
var CtaSectionWrapper = styled(Row).withConfig({
    componentId: "sc-84a20acd-1"
})([
    "min-width:278px;"
]);
var SyledIcon = styled(FaireMarketIcon).attrs({
    size: "32px"
}).withConfig({
    componentId: "sc-84a20acd-2"
})([
    "",
    "{align-self:start;}"
], responsiveMediaQueries.mobile);
